<svelte:options accessors/>
<script>
    import NauiFilters from "../../naui/components/NauiFilters.svelte";
    import NauiTable from "../../naui/components/NauiTable.svelte";
    import Chart from 'chart.js/auto';
    import {createEventDispatcher, onMount} from 'svelte';

    export let filters;

    export let data;
    export let columns;
    export let count;

    const dispatch = createEventDispatcher();

    let filtersCmpt;
    let canvasBar;

    let canvasPieBodegas;
    let canvasPieMetros;

    onMount(() => {
        setTimeout(() => {
            dispatch('init');
        }, 50);

        // TODO GRAFICA DE MOVIMIENTOS
        const barData = {
            labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dec'],
            datasets: [{
                label: 'Nuevos ingresos registrados',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: 'rgb(73, 88, 103)',
                borderColor: 'rgb(73, 88, 103)',
                borderWidth: 1
            }, {
                label: 'Nuevas salidas registradas',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: 'rgb(201, 217, 207)',
                borderColor: 'rgb(201, 217, 207)',
                borderWidth: 1
            }]
        };

        const configBar = {
            type: 'bar',
            data: barData,
            options: {
                scales: {
                    y: {
                        beginAtZero: true
                    }
                },
                plugins: {
                    legend: {
                        align: 'end'
                    }
                }
            },
        };

        new Chart(canvasBar, configBar);
    });

</script>

<div class="py-15">
    <NauiFilters bind:this={filtersCmpt} {filters} on:filtered/>
</div>

<div class="p-15 shadow radius 2">
    <h2 class="text-l mb-1">Ocupación bodegas mes a mes</h2>
    <canvas bind:this={canvasBar} width="1200" height="300"></canvas>
</div>

<hr>

<div style="width: calc(100vw - 150px); overflow-x: scroll">
    <NauiTable {data}
               bind:total={count}
               {columns}
               on:action={(evt) => dispatch('action', evt.detail)}
               on:checked
               on:order/>
</div>
